import { assocPath, curry, path } from 'ramda';

export const mapPath = curry(
  (
    thePath: (string | number)[],
    f: (..._: any[]) => any,
    obj: { [key: string]: any },
  ) => assocPath(thePath, f(path(thePath, obj)), obj),
);
